import { createBrowserRouter } from "react-router-dom";
import OldHomePage from "../Pages/OldHomePage/OldHomePage";
import FreelancerPage from "../Pages/FreelancerPage/FreelancerPage";
import RegularLayout from "../Layouts/Regular/RegularLayout";
import App from "../App";
import DarkLayout from "../Layouts/Dark/DarkLayout";
import PricingCalcPage from "../Pages/PricingCalc/PricingCalcPage";
import ProjectsPage from "../Pages/Projects/ProjectsPage";
import HomePage from "../Pages/HomePage/HomePage";
// import AboutPage from "../Pages/AboutPage/AboutPage";
// import ServicePage from "../Pages/ServicePage/ServicePage";
// import PortfolioPage from "../Pages/PortfolioPage/PortfolioPage";
// import BlogPage from "../Pages/BlogPage/BlogPage";
// import ContactPage from "../Pages/ContactPage/ContactPage";
// import SoftwarePage from "../Pages/SoftwarePage/SoftwarePage";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        path: "",
        element: <DarkLayout />,
        children: [
          {
            path: "",
            element: <HomePage />,
          },
          // {
          //   path: "about",
          //   element: <AboutPage />,
          // },
          // {
          //   path: "service",
          //   element: <ServicePage />,
          // },
          // {
          //   path: "portfolio",
          //   element: <PortfolioPage />,
          // },
          // {
          //   path: "blog",
          //   element: <BlogPage />,
          // },
          // {
          //   path: "contact",
          //   element: <ContactPage />,
          // },
          // {
          //   path: "software",
          //   element: <SoftwarePage />,
          // },
        ],
      },
      // {
      //   path: "/old",
      //   element: <RegularLayout />,
      //   children: [
      //     {
      //       path: "",
      //       element: <OldHomePage />,
      //     },
      //   ],
      // },
      // {
      //   path: "/freelancer",
      //   element: <DarkLayout />,
      //   children: [
      //     {
      //       path: "",
      //       element: <FreelancerPage />,
      //     },
      //   ],
      // },
      // {
      //   path: "/projects",
      //   element: <DarkLayout />,
      //   children: [
      //     {
      //       path: "",
      //       element: <ProjectsPage />,
      //     },
      //   ],
      // },
      {
        path: "/calculator",
        element: <DarkLayout />,
        children: [
          {
            path: "",
            element: <PricingCalcPage />,
          },
        ],
      },
    ],
  },
]);
